<template>
    <div class="d-flex flex-wrap align-center ga-3">
        <v-text-field v-model="dal" type="date" label="Dal" density="compact" hide-details clearable
            style="max-width: 170px" />
        <v-text-field v-model="al" type="date" label="Al" density="compact" hide-details clearable
            style="max-width: 170px" />

        <v-btn-group density="compact" variant="outlined" divided>
            <v-btn @click="tutto">Tutto</v-btn>
            <v-btn @click="daInizioAnno">Da inizio anno</v-btn>
            <v-btn @click="annoScorso">Anno scorso</v-btn>
            <v-btn @click="ultimi12Mesi">Ultimi 12 mesi</v-btn>
        </v-btn-group>

        <v-alert v-if="periodoNonValido" type="warning" density="compact" variant="tonal" class="py-1">
            La data iniziale è successiva a quella finale.
        </v-alert>
    </div>
</template>

<script>
import Functions from "@/utils/functions.js";

export default {
    name: "FiltroPeriodoComponent",

    computed: {
        dal: {
            get() { return this.$store.state.statistiche.dal || ""; },
            set(v) { this.imposta(v, this.al); },
        },
        al: {
            get() { return this.$store.state.statistiche.al || ""; },
            set(v) { this.imposta(this.dal, v); },
        },
        periodoNonValido() {
            return !!this.dal && !!this.al && this.dal > this.al;
        },
    },

    methods: {
        imposta(dal, al) {
            this.$store.commit("statistiche/SET_PERIODO", { dal, al });
        },

        tutto() {
            this.imposta(null, null);
        },

        daInizioAnno() {
            const oggi = new Date();
            this.imposta(Functions.dataIso(new Date(oggi.getFullYear(), 0, 1)), Functions.dataIso(oggi));
        },

        annoScorso() {
            const anno = new Date().getFullYear() - 1;
            this.imposta(Functions.dataIso(new Date(anno, 0, 1)), Functions.dataIso(new Date(anno, 11, 31)));
        },

        ultimi12Mesi() {
            const oggi = new Date();
            const inizio = new Date(oggi.getFullYear() - 1, oggi.getMonth(), oggi.getDate() + 1);
            this.imposta(Functions.dataIso(inizio), Functions.dataIso(oggi));
        },
    },
};
</script>
